import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { MasterDataPort } from '@service/preclinical/master-data.port';
import { OrdersService } from '@infra-services/orders/orders.service';
import { Site, ExamType, Region } from '@model/filter/filter-options.model';

@Injectable({
  providedIn: 'root'
})
export class MasterDataAdapter implements MasterDataPort {
  private readonly ordersService = inject(OrdersService);

  getSites(): Observable<Site[]> {
    return this.ordersService.getSites();
  }

  getExamTypes(): Observable<ExamType[]> {
    return this.ordersService.getExamTypes();
  }

  getRegions(): Observable<Region[]> {
    return this.ordersService.getRegions();
  }

  getDiagnoses(): Observable<{ id: string; name: string }[]> {
    return this.ordersService.getDiagnoses();
  }

  getSpecialists(): Observable<{ id: string; name: string }[]> {
    return this.ordersService.getSpecialists();
  }

  getPriorities(): Observable<{ id: string; name: string }[]> {
    return this.ordersService.getPriorities();
  }

  getLaboratories(): Observable<{ id: string; name: string }[]> {
    return this.ordersService.getLaboratories();
  }

  getReprocessCauses(): Observable<{ id: string; name: string }[]> {
    return this.ordersService.getReprocessCauses();
  }

  getReprocessStatuses(): Observable<{ id: string; name: string }[]> {
    return this.ordersService.getReprocessStatuses();
  }

  getSpecimenContainers(): Observable<{ id: string; name: string }[]> {
    return this.ordersService.getSpecimenContainers();
  }

  getProviders(): Observable<{ id: string; name: string }[]> {
    return this.ordersService.getProviders();
  }

  getInsuranceCompanies(): Observable<{ id: string; name: string }[]> {
    return this.ordersService.getInsuranceCompanies();
  }
}
